module.exports = __webpack_public_path__ + "img/login-aside.658ecd92.svg";